import createTradePlanCopy from '../../../../../../../../classes/tradePlan/createTradePlanCopy';
import { submitTradePlan } from './submitTradePlan';
import {GetErrorMessage} from "./breakBounceErrorMessages";

const OPTION_INSTRUMENTS = new Set(['option', 'future_option']);

export function addBounceSetup({
  contextMenuProps,
  currentPrice,
  tradePlanForm,
  autoSend,
  scaleY,
  websocketStore,
}) {
  // TODO consolidate addBounce, addBreak, et al
  // TODO hold an array of setups somewhere to allow for multiple, coordinated Trade Plans

  const setup = 'BOUNCE';
  // TODO make sure new BOUNCE is consistent with direction
  const direction = tradePlanForm?.direction ?? null;

  if (currentPrice === null) {
    tradePlanForm.setValidationStatus({
      status: false,
      message: 'Issue obtaining current price with selected data source.',
    });
    return;
  }

  const priceOfSetup = scaleY.invert(contextMenuProps.yCoordinate);
  const instrument = tradePlanForm.instrument;

  // Respect an explicit LONG/SHORT selection; only infer direction when the form is NONE or BOTH.
  const canInferDirection = direction === 'NONE' || direction === 'BOTH';
  const isLongSetupValid =
    priceOfSetup >= 0.0 &&
    Number(currentPrice) > priceOfSetup &&
    (tradePlanForm.direction === 'LONG' || canInferDirection);
  const isShortSetupValid =
    priceOfSetup >= 0.0 &&
    Number(currentPrice) < priceOfSetup &&
    (tradePlanForm.direction === 'SHORT' || canInferDirection);

  if (isLongSetupValid) {
    tradePlanForm.setSetup('BOUNCE', { priceToBreak: priceOfSetup });
  }

  if( isShortSetupValid ) {
    tradePlanForm.setSetup('BOUNCE', { priceToBreak: priceOfSetup });
  }

  if( !isLongSetupValid && !isShortSetupValid ) {
    const err = GetErrorMessage({direction, setup, currentPrice, price: priceOfSetup})
    tradePlanForm.setValidationStatus(err);
    return
  }

  if (autoSend) {
    let om = null;
    if( OPTION_INSTRUMENTS.has(instrument) )
      om = tradePlanForm.optionManagement.returnJson();

    // make sure direction suits the setup
    const overrides = { goLong: isLongSetupValid, goShort: isShortSetupValid, optionManagement: om }
    submitTradePlan({ currentPrice, tradePlanForm, overrides, websocketStore });
  }
}
